export default __webpack_public_path__ + "static/1073-55ecef344fa86ae91cdb18f1d10a5084.gif";